import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, Typography, Alert } from '@mui/material';
import { RootState } from '../types';
import ClientList from '../components/clients/ClientList';
import ClientDetail from '../components/clients/ClientDetail';
import ClientAccessManagement from '../components/clients/ClientAccessManagement';

const ClientsPage: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  
  // Check if user is admin
  const isAdmin = user?.role === 'global_admin';
  
  // If user is not admin, show access denied message
  if (!isAdmin) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          Access Denied: Only administrators can access client management.
        </Alert>
        <Typography variant="body1">
          You don't have permission to view this page. Please contact an administrator if you need access.
        </Typography>
      </Box>
    );
  }
  
  return (
    <Routes>
      <Route path="/" element={<ClientList />} />
      <Route path="/:clientId" element={<ClientDetail />} />
      <Route path="/:clientId/edit" element={<ClientDetail />} />
      <Route path="/:clientId/access" element={<ClientAccessManagement />} />
      <Route path="*" element={<Navigate to="/clients" />} />
    </Routes>
  );
};

export default ClientsPage;